import { useCallback } from 'react';

import { CHART_THEME_NAME, CHART_THEME_TOKENS, ChartThemeTokens } from 'constants/theme';
import { adaptSeriesColor, registerChartThemes } from 'helper/echartsTheme';
import useDocumentTheme from 'hooks/theme/useDocumentTheme';

registerChartThemes();

/**
 * Nome do tema ECharts do tema atual — passe em `<ReactECharts theme={useChartTheme()} />`.
 * Ao trocar, o echarts-for-react recria o gráfico com eixos/grade/tooltip do novo tema.
 * Não fixe cor de eixo/texto/grade no `option`: isso sobrepõe o tema.
 */
export default function useChartTheme(): string {
  return CHART_THEME_NAME[useDocumentTheme()];
}

/** Chrome do gráfico no tema atual, para o raro `option` que precisa de cor explícita. */
export function useChartTokens(): ChartThemeTokens {
  return CHART_THEME_TOKENS[useDocumentTheme()];
}

/**
 * Adaptador de cor de série: `const cor = useSeriesColor(); ... color: cor(DARK_BLUE)`.
 * No claro devolve a própria cor; no escuro troca navy/preto/cinzas por equivalentes legíveis.
 */
export function useSeriesColor(): (color: string) => string {
  const theme = useDocumentTheme();
  return useCallback((color: string) => adaptSeriesColor(color, theme), [theme]);
}
